import { fork, all } from 'redux-saga/effects';
import productSaga from './hgproduct';
import orderSaga from './hgorder';

export default function* happySaga() {
  yield all([fork(productSaga), fork(orderSaga)]);
}
